import { StaticImage } from 'gatsby-plugin-image'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import "./Footer.css"

const logo = {
  src: '../../images/logo.jpg',
  alt: 'Buxbear logo'
}
class Footer extends Component {
  render() {
    const { borderTop, t } = this.props

    return (
      <footer className="footer">
        <div
          className="footer-inner-wrap"
          style={{
            borderTop: borderTop && 'solid 1px var(--line)'
          }}
        >
          <div className="footer-block">
            <StaticImage 
              className="footer-logo"
              placeholder="tracedSVG"
              objectFit="contain"
              {...logo} 
            />
            <p className="footer-text">{`©${new Date().getFullYear()}`}</p>
            {t(`footer:texts`, { returnObjects: true }).map((text, index) => {
              return <p key={index} className="footer-text">{text}</p>
            })}
          </div>
          <div className="footer-block">
            {t(`footer:links`, { returnObjects: true }).map((link, index) => {
              return (
                <a
                  key={index}
                  className="footer-link"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.text}
                </a>
              )
            })}
          </div>
        </div>
      </footer>
    )
  }
}
export default withTranslation(['footer'])(Footer)
